'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { OptimizedImage } from '@/components/images';
import { AnimatedButton } from '@/components/ui/animated-button';
import { Cancel01Icon } from '@/components/ui/icon/glyphs';
import { Panel, PanelContent } from '@/components/ui/panel';
import { onEvent } from '@/events';
import { useHydrated } from '@/hooks/ui/use-hydrated';
import { appUpsellProperties } from '@/lib/app-upsells/analytics';
import { cn } from '@/lib/ui/utils';
import { usePortfolioAppUpsellDismissalStore } from '@/stores/portfolio-app-upsell-dismissal';
import { AppDownloadAction } from './app-download-action';
import { useUpsellImpression } from './use-upsell-impression';
export function PortfolioAppUpsellCard(t0) {
  const $ = _c(22);
  const {
    className
  } = t0;
  const t = useTranslations("app_upsells");
  const dismissed = usePortfolioAppUpsellDismissalStore(_temp);
  const dismiss = usePortfolioAppUpsellDismissalStore(_temp2);
  const hydrated = useHydrated();
  const ref = useUpsellImpression("portfolio");
  if (hydrated && dismissed) {
    return null;
  }
  let t1;
  if ($[0] !== dismiss) {
    t1 = function handleDismiss() {
      onEvent("app_upsell_dismissed", appUpsellProperties("portfolio", "portfolio"));
      dismiss();
    };
    $[0] = dismiss;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleDismiss = t1;
  let t2;
  if ($[2] !== className) {
    t2 = cn("relative min-w-0 flex-1", className);
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="pointer-events-none absolute top-1/2 left-0 -translate-x-6 -translate-y-1/2" aria-hidden="true"><OptimizedImage variant="thumbnail" src="/icons/morfi-logomark.svg" alt="" size="size-20" className="bg-transparent" preview={false} nsfw={false} loadReveal="none" /></div>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("portfolio_title");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <div className="min-w-0 flex-1 pr-6 sm:pr-0"><h2 className="text-body font-medium">{t4}</h2></div>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <AppDownloadAction surface="portfolio" />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5) {
    t7 = <Panel className="relative h-full overflow-hidden"><PanelContent className="relative flex flex-1 flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">{t3}<div className="relative flex min-w-0 flex-1 flex-col gap-3 pl-[calc(theme(spacing.20)+0.75rem-1rem-1.5rem)] sm:flex-row sm:items-center sm:justify-between">{t5}{t6}</div></PanelContent></Panel>;
    $[10] = t5;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t) {
    t8 = t("portfolio_dismiss");
    $[12] = t;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== handleDismiss || $[15] !== t8) {
    t9 = <AnimatedButton variant="secondary" size="xs" prefix={Cancel01Icon} onClick={handleDismiss} aria-label={t8} disableHoverScale={true} className="absolute top-2 right-2 z-10 translate-x-1/2 -translate-y-1/2" />;
    $[14] = handleDismiss;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== ref || $[18] !== t2 || $[19] !== t7 || $[20] !== t9) {
    t10 = <div ref={ref} className={t2} data-testid="portfolio-app-upsell-card">{t7}{t9}</div>;
    $[17] = ref;
    $[18] = t2;
    $[19] = t7;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
}
function _temp2(state_0) {
  return state_0.dismiss;
}
function _temp(state) {
  return state.dismissed;
}